export const removeMobileMenuOnResize = () => {
    if (window.innerWidth > 1300)  {
        if (document.body.classList.contains('show-mobile-menu')) {
            document.body.classList.remove('show-mobile-menu');
        }
        const openItem = document.querySelector('li.has-mega-menu.open');
        const openHeader = document.querySelector('header.mega-menu-open');
        if (openItem) {
        openItem.classList.remove('open');
        }
        if (openHeader) {
            openHeader.classList.remove('mega-menu-open');
        }
    }
}

window.addEventListener('resize', removeMobileMenuOnResize);